const Items = [
    {
        id: 1,
        Title: "Galaxy Tab S6 Lite 10.4-inch Android Tablet 128GB",
        Cat: "gadgets",
        Price: "537,000",
        Img: "./Assets/notebook.png",
    },
    {
        id: 2,
        Title: "Acer Aspire 2 in 1 Laptop 16GB 256SSD Core i5",
        Cat: "gadgets",
        Price: "370,000",
        Img: "./Assets/acer.png",
    },
    {
        id: 3,
        Title: "Airpod Pro",
        Cat: "gadgets",
        Price: "150,400",
        Img: "./Assets/airpod-pro.png",
    },
    {
        id: 4,
        Title: "Airpod 2",
        Cat: "gadgets",
        Price: "112,070",
        Img: "./Assets/airpod2.jpeg",
    },
    {
        id: 5,
        Title: "Airpod Max",
        Cat: "gadgets",
        Price: "707,000",
        Img: "./Assets/airpodmax.jpg",
    },
    {
        id: 6,
        Title: "Airpod 2",
        Cat: "gadgets",
        Price: "127,000",
        Img: "./Assets/airpodp2.jpg",
    },
    {
        id: 7,
        Title: "Casio G-Shock Black",
        Cat: "wristwatches",
        Price: "399,999",
        Img: "./Assets/CasioG-shock.png",
    },
    {
        id: 8,
        Title: "Club De Nuit Intense Men",
        Cat: "perfumes",
        Price: "67,550",
        Img: "./Assets/club-nuit.jpeg",
    },
    {
        id: 9,
        Title: "Green Gucci Purse",
        Cat: "bags",
        Price: "720,000",
        Img: "./Assets/greengucci.png",
    },
    {
        id: 10,
        Title: "Airpod Max",
        Cat: "gadgets",
        Price: "607,000",
        Img: "./Assets/greenmax.jpg",
    },
    {
        id: 11,
        Title: "Casio G-Shock M-4350",
        Cat: "wristwatches",
        Price: "237,000",
        Img: "./Assets/gshock2.png",
    },
    {
        id: 12,
        Title: "Green Gucci Suede Purse",
        Cat: "bags",
        Price: "150,000",
        Img: "./Assets/gucci-purse.png",
    },

    {
        id: 13,
        Title: "HP 15 Core i5 512SSD 8GB",
        Cat: "gadgets",
        Price: "431,000",
        Img: "./Assets/hp-laptop.jpg",
    },
    {
        id: 14,
        Title: "Lattafa Hayaati Perfume",
        Cat: "perfumes",
        Price: "27,000",
        Img: "./Assets/hyatti.png",
    },
    {
        id: 15,
        Title: "Apple Iphone 12 256GB",
        Cat: "phones",
        Price: "620,000",
        Img: "./Assets/iphone12.jpg",
    },
    {
        id: 16,
        Title: "Oculus Quest 2",
        Cat: "gadgets",
        Price: "402,000",
        Img: "./Assets/oculus2.png",
    },
    {
        id: 17,
        Title: "Audemars Piguet Royal Oak",
        Cat: "wristwatches",
        Price: "350,120,000",
        Img: "./Assets/piguet-oak.png",
    },
    {
        id: 18,
        Title: "Apple Iphone 12 Pro Max 512GB",
        Cat: "phones",
        Price: "879,000",
        Img: "./Assets/pro-max.png",
    },
    {
        id: 19,
        Title: "Richard Mille RM 66 Flying Tourbillon Red",
        Cat: "wristwatches",
        Price: "514,000,000",
        Img: "./Assets/redmille.png",
    },
    {
        id: 20,
        Title: "Richard Mille RM 002-V2 Tourbillon Black",
        Cat: "wristwatches",
        Price: "610,000,000",
        Img: "./Assets/richardmille.png",
    },
    {
        id: 21,
        Title: "Rolex Datejust 41",
        Cat: "wristwatches",
        Price: "79,000,065",
        Img: "./Assets/rolex-datejust.jpg",
    },
    {
        id: 22,
        Title: "Samsung S23 Ultra 512GB",
        Cat: "phones",
        Price: "820,000",
        Img: "./Assets/s23Ultra.jpg",
    },
    {
        id: 23,
        Title: "Samsung S24 Ultra 512GB",
        Cat: "phones",
        Price: "537,000",
        Img: "./Assets/s24-ultra.jpg",
    },
    {
        id: 24,
        Title: "Hermes Izmar Slippers (Brown)",
        Cat: "footwears",
        Price: "84,000",
        Img: "./Assets/hermes.webp",
    },
    {
        id: 25,
        Title: "LG Inverter Air-Conditioner",
        Cat: "electronics",
        Price: "384,000",
        Img: "./Assets/ac.png",
    },
    {
        id: 26,
        Title: "Bullet Vibrator (60% Off)",
        Cat: "pleasures",
        Price: "4,000",
        Img: "./Assets/bullet.webp",
    },
    {
        id: 27,
        Title: "Canon C59E",
        Cat: "gadgets",
        Price: "804,069",
        Img: "./Assets/canon-c.jpg",
    },
    {
        id: 28,
        Title: "Santos De Cartier",
        Cat: "wristwatches",
        Price: "44,700,000",
        Img: "./Assets/Cartier.avif",
    },
    {
        id: 29,
        Title: "Cock Ring (75% Off)",
        Cat: "pleasures",
        Price: "2,000",
        Img: "./Assets/cock-ring.webp",
    },
    {
        id: 30,
        Title: "Hp Elitebook 840 G5 16GB 512SSD",
        Cat: "gadgets",
        Price: "514,000",
        Img: "./Assets/Elitebook.png",
    },
    {
        id: 31,
        Title: "Samsung Galaxy Smartwatch",
        Cat: "gadgets",
        Price: "325,000",
        Img: "./Assets/galaxy-watch.png",
    },
    {
        id: 32,
        Title: "Samsung Galaxy Gear S3",
        Cat: "gadgets",
        Price: "290,000",
        Img: "./Assets/gears3.jpg",
    },
    {
        id: 33,
        Title: "Hisense 55inches Smart Tv (2024)",
        Cat: "electronics",
        Price: "573,000",
        Img: "./Assets/hisenseTv.webp",
    },
    {
        id: 34,
        Title: "Macbook M3 2023 15INCHES 16GB 1TB SSD",
        Cat: "gadgets",
        Price: "3,231,000",
        Img: "./Assets/macbook-m3.png",
    },
    {
        id: 35,
        Title: "Nicon D5300l",
        Cat: "gadgets",
        Price: "939,070",
        Img: "./Assets/nicon-d5300.jpg",
    },
    {
        id: 36,
        Title: "Ps4 Controller (Dual-Shock)",
        Cat: "gadgets",
        Price: "80,000",
        Img: "./Assets/ps4-controller.png",
    },
    {
        id: 37,
        Title: "PS4 Slim",
        Cat: "gadgets",
        Price: "300,000",
        Img: "./Assets/ps4.png",
    },
    {
        id: 38,
        Title: "PS5 Controller",
        Cat: "gadgets",
        Price: "110,000",
        Img: "./Assets/ps5-controller.webp",
    },
    {
        id: 39,
        Title: "PS5",
        Cat: "gadgets",
        Price: "687,000",
        Img: "./Assets/Ps5.webp",
    },
    {
        id: 40,
        Title: "Rabbit Vibrator (20% Off)",
        Cat: "pleasures",
        Price: "11,000",
        Img: "./Assets/rabbit.webp",
    },
    {
        id: 41,
        Title: "Hisense Refridgerator 310ltrs",
        Cat: "electonics",
        Price: "354,000",
        Img: "./Assets/refridgerator.png",
    },
    {
        id: 42,
        Title: "Rose Vibrator (80% Off)",
        Cat: "pleasures",
        Price: "4,000",
        Img: "./Assets/rose-v.webp",
    },
    {
        id: 43,
        Title: "Apple Series 3 42mm",
        Cat: "gadgets",
        Price: "311,000",
        Img: "./Assets/series-3.jpg",
    },
    {
        id: 44,
        Title: "Apple Series 5 36mm",
        Cat: "gadgets",
        Price: "501,000",
        Img: "./Assets/series-5.png",
    },
    {
        id: 45,
        Title: "Sony Camera Alpha7",
        Cat: "gadgets",
        Price: "1,001,000",
        Img: "./Assets/sony-A7.jpg",
    },
    {
        id: 46,
        Title: "Versace Men Shirt",
        Cat: "clothings",
        Price: "123,050",
        Img: "./Assets/versace-men.png",
    },
    {
        id: 47,
        Title: "Apple Series 3 42mm",
        Cat: "gadgets",
        Price: "311,000",
        Img: "./Assets/series-3.jpg",
    },
    {
        id: 48,
        Title: "PS5",
        Cat: "gadgets",
        Price: "700,000",
        Img: "./Assets/Ps5.webp",
    },
    {
        id: 49,
        Title: "Macbook M3 2023 15INCHES 16GB 1TB SSD",
        Cat: "gadgets",
        Price: "3,131,000",
        Img: "./Assets/macbook-m3.png",
    },
    {
        id: 51,
        Title: "Hisense Refridgerator 310ltrs",
        Cat: "electonics",
        Price: "304,000",
        Img: "./Assets/refridgerator.png",
    },
    {
        id: 52,
        Title: "Samsung S24 Ultra 512GB",
        Cat: "phones",
        Price: "437,000",
        Img: "./Assets/s24-ultra.jpg",
    },
    {
        id: 53,
        Title: "Hermes Izmar Slippers (Brown) (45% Off)",
        Cat: "footwears",
        Price: "24,000",
        Img: "./Assets/hermes.webp",
    },
];

export default Items